// bernie
import { SerializedData, Store } from 'bernie-core';
import { Logger } from 'bernie-logger';

// data
import { PzSource } from 'sources/pz-source';
import { PzUserSignUp, PzTerms } from 'models/pz';

import { observable, action, makeObservable } from 'mobx';

export class PzStore extends Store {
  public terms = '';
  public termsId;
  public termsState; // 'pending', 'done' or 'error'

  constructor(private pzSource: PzSource, state: SerializedData = {}, logger: Logger) {
    super(state, logger);

    makeObservable(this, {
      terms: observable,
      termsId: observable,
      termsState: observable,
      termsFetchSuccess: action,
      termsFetchFailure: action,
    });
  }

  public hydrate(data: SerializedData): void {
    if (data.pzSource) {
      Object.assign(this.pzSource, data.pzSource);
    }

    delete data.pzSource;
    Object.assign(this, data);
  }

  public async fetchTerms(country: string, locale: string) {
    this.terms = '';
    this.termsState = 'pending';

    try {
      const newTerms = await this.pzSource.getPartnerizeTerms(locale, country);
      this.termsFetchSuccess(newTerms);
    } catch (e) {
      this.termsFetchFailure(e);
    }
  }

  public termsFetchSuccess = (terms: PzTerms) => {
    this.terms = terms.terms_and_conditions;
    this.termsId = terms.ref_terms_and_conditions_locale_id;
    this.termsState = 'done';
  };

  public termsFetchFailure = (error) => {
    this.termsState = 'error';
  };

  public async fetchPartner(token: string) {
    return await this.pzSource.getPartner(token);
  }

  public async getExpediaGroupTerms(locale: string, country: string) {
    return await this.pzSource.getExpediaGroupTerms(locale, country);
  }

  public createUser(programName: string, user: PzUserSignUp) {
    return this.pzSource.createUser(programName, user);
  }

  public assignCampaign(programName: string, partnerId: string, campaignTermsId: string, accessToken: string) {
    return this.pzSource.assignCampaign(programName, partnerId, campaignTermsId, accessToken);
  }
}
